import { useEffect } from 'react';
import { App } from '@capacitor/app';
import { useNavigate } from 'react-router-dom';
import { isNativeApp } from '../lib/platform';

function canGoBackInApp() {
  const idx = window.history.state?.idx;
  if (typeof idx === 'number') return idx > 0;
  return window.history.length > 1;
}

/** Maps Android hardware back to React Router history; exits only at the stack root. */
export function useAndroidBackButton() {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isNativeApp()) return undefined;

    let removed = false;
    let listenerHandle: Awaited<ReturnType<typeof App.addListener>> | null = null;

    void App.addListener('backButton', () => {
      if (canGoBackInApp()) {
        navigate(-1);
        return;
      }
      void App.exitApp();
    }).then((handle) => {
      if (removed) {
        void handle.remove();
      } else {
        listenerHandle = handle;
      }
    });

    return () => {
      removed = true;
      void listenerHandle?.remove();
    };
  }, [navigate]);
}
